import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NspRoutingModule } from './nsp-routing.module';
import { NspActivationContainerComponent } from './nsp-activation-container/nsp-activation-container.component';
import { NspActivationInternetContainerComponent } from './nsp-activation-internet-container/nsp-activation-internet-container.component';
import { NspActivationMobileContainerComponent } from './nsp-activation-mobile-container/nsp-activation-mobile-container.component';
import { TranslationModule } from '@proximus/ng-common';
import { EffectsModule } from '@ngrx/effects';
import { NspEffects } from './store/effects/nsp.effects';
import { SharedModule } from '../shared/shared.module';
import { AlertModule } from '@proximus/ng-common-components';
import { NspMobileListComponentComponent } from './nsp-mobile-list-component/nsp-mobile-list-component.component';
import { NspActivationSkeletonComponent } from './nsp-activation-skeleton/nsp-activation-skeleton.component';
import { NspInternetListComponentComponent } from './nsp-internet-list-component/nsp-internet-list-component.component';
import { NspManageContainerComponent } from './nsp-manage-container/nsp-manage-container.component';
import { NspManageSkeletonComponent } from './nsp-manage-skeleton/nsp-manage-skeleton.component';
import { NspBasketModalComponent } from './nsp-basket-modal/nsp-basket-modal.component';
import { NspStatisticsBannerComponent } from './nsp-statistics-banner/nsp-statistics-banner.component';
import { DesignSystemModule } from '@proximus/pxs-angular-design-system';

@NgModule({
  declarations: [
    NspActivationContainerComponent,
    NspActivationInternetContainerComponent,
    NspActivationMobileContainerComponent,
    NspMobileListComponentComponent,
    NspActivationSkeletonComponent,
    NspInternetListComponentComponent,
    NspManageContainerComponent,
    NspManageSkeletonComponent,
    NspBasketModalComponent,
    NspStatisticsBannerComponent,
  ],
  imports: [
    CommonModule,
    NspRoutingModule,
    TranslationModule,
    EffectsModule.forFeature([NspEffects]),
    SharedModule,
    AlertModule,
    DesignSystemModule,
  ],
})
export class NspModule {}
